module.exports = __webpack_public_path__ + "572302a3f389d3e70623f268bf123f1b.svg";